import { BaseEditViewStore } from 'core/stores';
import { NikoFacilityOrderNewFlowInventoryEditEmergencySupplyDaysModalForm } from 'application/niko-facility-order-inventory/forms';
import { FacilityService } from 'application/facility/services';
import { action } from "mobx";

class NikoFacilityOrderNewFlowInventoryEditEmergencySupplyDaysModal extends BaseEditViewStore {
    constructor(rootStore, componentProps) {
        const facilityInventoryCountHeader = componentProps.modalParams.data.facilityInventoryCountHeader;
        const facilityOrder = componentProps.modalParams.data.facilityOrder;
        const facilityService = new FacilityService(rootStore.application.baasic.apiClient);
        super(rootStore, {
            name: 'facility-order-new-flow-inventory-edit-emergency-supply-days',
            Form: NikoFacilityOrderNewFlowInventoryEditEmergencySupplyDaysModalForm,
            id: facilityInventoryCountHeader && facilityInventoryCountHeader.id,
            authorization: 'portalSection.update',
            actions: () => {
                return {
                    get: async () => {
                        var response = (await facilityService.get(facilityOrder.facilityId)).data;
                        return response;
                    },
                    update: async resource => {
                        this.item.emergencySupplyDays = resource.emergencySupplyDays;
                        const response = await facilityService.update({...this.item});
                        facilityOrder.facility.emergencySupplyDays =  resource.emergencySupplyDays;
                        return response.data;
                    }
                }
            },
            FormClass: NikoFacilityOrderNewFlowInventoryEditEmergencySupplyDaysModalForm
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.refreshInventoryCalculation = componentProps.modalParams.data.refreshInventoryCalculation;
    }

    @action
    async initialize() {
        if (this.isEdit) {
            await this.getResource();
        } else {
            this.form.clear();
            this.form.$("emergencySupplyDays").value = 0;
        }
    }

    @action.bound
    async updateResource(resource) {
        if (!this.actions.update) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.update({
                ...resource
            });

            if (this.refreshInventoryCalculation) {
                await this.refreshInventoryCalculation();
            }

            this.form.setFieldsDisabled(false);

            this.modalParams.close();
            this.rootStore.notificationStore.success("FACILITY_ORDER_NEW_FLOW_INVENTORY.EDIT_EMERGENCY_SUPPLY_DAYS.SUCCESS_UPDATE");
        }
        catch (err) {
            this.form.setFieldsDisabled(false);
            return this.onUpdateError(err);
        }
    }
}

export default NikoFacilityOrderNewFlowInventoryEditEmergencySupplyDaysModal;
